import { render, staticRenderFns } from "./ProjectHeader.vue?vue&type=template&id=0f915ee8&scoped=true"
import script from "./ProjectHeader.vue?vue&type=script&lang=js"
export * from "./ProjectHeader.vue?vue&type=script&lang=js"
import style0 from "./ProjectHeader.vue?vue&type=style&index=0&id=0f915ee8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f915ee8",
  null
  
)

export default component.exports